import { chevronBackOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerPaymentMethod, PaymentInfo, PaymentMethodEnum, PaypalActionObj } from 'src/shared/models/payment.model';
import { PayWithPayPalComponent } from "./components/pay-with-paypal/pay-with-paypal.component";
import { PayWithPayrexxComponent } from "./components/pay-with-payrexx/pay-with-payrexx.component";
import { IonButton, IonIcon } from "@ionic/angular/standalone";
import { PayWithSavedCardComponent } from "./components/pay-with-saved-card/pay-with-saved-card.component";
import { PayWithCreditCardComponent } from "./components/pay-with-credit-card/pay-with-credit-card.component";
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'vl-pay-with-wrapper',
	templateUrl: './pay-with-wrapper.component.html',
	styleUrls: ['./pay-with-wrapper.component.scss'],
 imports: [IonIcon, IonButton, NgSwitch, NgSwitchCase, NgIf, TranslatePipe, PayWithPayPalComponent, PayWithPayrexxComponent, PayWithSavedCardComponent, PayWithCreditCardComponent],
})
export class PayWithWrapperComponent implements OnInit {
	@Input() paymentType: { type: 'new-card' | 'saved-card', card: CustomerPaymentMethod };
	@Input() paymentInfo: PaymentInfo;
	@Input() giropayFullName: string;
	@Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
	@Output() onError: EventEmitter<any> = new EventEmitter<any>();
	@Output() back: EventEmitter<any> = new EventEmitter<any>();
	@Output() onValidationError: EventEmitter<any> = new EventEmitter<any>();
	@Output() onActionPaypal: EventEmitter<PaypalActionObj> = new EventEmitter<PaypalActionObj>();

	paymentEnums = PaymentMethodEnum;

	constructor() {
    	addIcons({ chevronBackOutline });
	}

	ngOnInit() {
	}

}
